<!--
 * @Editor: chenqy
 * @Description: 发送短信
 * @Date: 2021-06-09 17:05:35
 * @LastEditors: Chenqy
 * @LastEditTime: 2022-04-18 12:04:43
-->
<template>
  <div class="teas-message ds-control">
    <div class="teas-message-header">
      <div class="teas-header-title">发短信</div>
      <div class="teas-header-send">
        <div class="teas-header-check" :class="{ 'teas-header-check-true': !isRightNowSend }" @click="handleSend(false)">
          <i v-show="!isRightNowSend" class="el-icon-check"></i>
        </div>
        <div class="teas-header-text">定时发送</div>
        <div class="teas-header-timer">
          <el-date-picker v-model="sendDate" v-show="!isRightNowSend" type="datetime" placeholder="请选择"> </el-date-picker>
        </div>
        <!-- <div
          class="teas-header-check"
          :class="{ 'teas-header-check-true': isRightNowSend }"
          @click="handleSend(true)"
        >
          <i v-show="isRightNowSend" class="el-icon-check"></i>
        </div>
        <div class="teas-header-text" style="margin-right: 40px">立即发送</div> -->
        <div class="teas-header-btn" @click="handleSendMessage('send')"><i class="el-icon-position"></i>发送</div>
        <div class="teas-header-btn" @click="handleSendMessage('draft')">保存至草稿箱</div>
        <el-upload
          class="teas-header-btn"
          slot="append"
          :headers="dsf.getDefaultHttpHeader()"
          :accept="accept"
          :action="action"
          :show-file-list="false"
          :on-progress="uploadProgress"
          :on-success="uploadSuccess"
          :on-error="uploadError"
        >
          <div class="teas-header-btn-text">导入手机号</div>
        </el-upload>
        <div class="teas-header-btn" @click="downloadMode">模版下载</div>
      </div>
    </div>
    <div class="teas-message-body">
      <div class="teas-body-left" :style="{ width: allNavList.length > 4 ? '535px' : '480px' }">
        <el-tabs v-model="navActive" @tab-click="handleChangeNav" class="teas-message-tabs">
          <el-tab-pane v-for="item in defaultNavList" :key="item.name" :label="item.title" :name="item.name" :lazy="true">
            <template v-if="!item.haschild || item.child.length == 0">
              <message-tree
                v-if="item.displayMode == 'tree'"
                :name="item.name"
                :ref="item.name"
                :apiAddress="item.url"
                :sms-data="item"
                @handleAdd="handleAddUser"
                @call-back="childCallback"
              />
              <index-bar
                v-else
                :name="item.name"
                :ref="item.name"
                :apiAddress="item.url"
                :sms-data="item"
                @handle-add="handleAddUser"
                @call-back="childCallback"
              />
            </template>
            <template v-else>
              <el-tabs :value="twoLevelActiveFind(item.name)" type="card" class="teas-card-tabs">
                <el-tab-pane
                  v-for="(tempItem, tempIndex) in item.child"
                  :key="'twoleveltree' + tempIndex"
                  :label="tempItem.title"
                  :name="tempItem.name"
                  :lazy="true"
                >
                  <message-tree
                    :name="tempItem.name"
                    :ref="tempItem.name"
                    :apiAddress="tempItem.url"
                    :sms-data="tempItem"
                    @handleAdd="handleAddUser"
                    @call-back="childCallback"
                  />
                </el-tab-pane>
              </el-tabs>
              <!-- <div class="sendmessage-twolevel-div">
                <div class="sendmessage-twoleveltab-div">
                  <div
                    class="sendmessage-twoleveltab-item"
                    v-for="(tempItem, tempIndex) in item.child"
                    :key="'twoleveltab' + tempIndex"
                    @click="clickTwoTab(index, tempItem)"
                  >
                    <div :class="tempIndex == 0 ? 'item-content-noborder' : 'item-content-normal'">
                      <div :class="tempItem.name == item.active ? 'item-content-select' : 'item-content-notselect'">
                        {{ tempItem.title || "" }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="sendmessage-twoleveltree-div"
                  v-for="(tempItem, tempIndex) in item.child"
                  :key="'twoleveltree' + tempIndex"
                  v-show="tempItem.name == item.active"
                >
                  <div class="teas-body-tree-c">
                    <message-tree
                      class="teas-body-tree"
                      :name="tempItem.name"
                      :ref="tempItem.name"
                      :apiAddress="tempItem.url"
                      :sms-data="tempItem"
                      @handleAdd="handleAddUser"
                      @call-back="childCallback"
                    />
                  </div>
                </div>
              </div> -->
            </template>
          </el-tab-pane>
        </el-tabs>

        <!-- <div class="teas-body-nav">
          <div class="teas-body-nav-box">
            <div class="teas-body-nav-really" :style="{ transform: 'translateX(' + navMargin + 'px)' }">
              <div
                class="teas-body-nav-item"
                :class="{ 'teas-item-active': item.name === navActive }"
                v-for="(item, index) in allNavList"
                :key="index"
                @click="handleChangeNav(item.name)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="teas-body-btn" v-if="allNavList.length > 4">
            <i class="el-icon-arrow-left" :class="{ 'arrow-disabled': navMargin === 0 }" @click="handleMoveNav(true)"></i>
            <i
              class="el-icon-arrow-right"
              :class="{
                'arrow-disabled': Math.abs(this.navMargin) >= Math.ceil(this.allNavList.length / 4 - 1) * 480,
              }"
              @click="handleMoveNav(false)"
            ></i>
          </div>
        </div> -->
        <!-- 搜索树 -->
        <!-- <div class="teas-body-tree-main" v-for="(item, index) in defaultNavList" :key="'treelist' + index" v-show="navActive === item.name">
          <template v-if="!item.haschild || item.child.length == 0">
            <div class="teas-body-tree-c">
              <message-tree
                class="teas-body-tree"
                :name="item.name"
                :ref="item.name"
                :apiAddress="item.url"
                :sms-data="item"
                @handleAdd="handleAddUser"
                @call-back="childCallback"
              />
            </div>
          </template>
          <template v-else>
            <div class="sendmessage-twolevel-div">
              <div class="sendmessage-twoleveltab-div">
                <div
                  class="sendmessage-twoleveltab-item"
                  v-for="(tempItem, tempIndex) in item.child"
                  :key="'twoleveltab' + tempIndex"
                  @click="clickTwoTab(index, tempItem)"
                >
                  <div :class="tempIndex == 0 ? 'item-content-noborder' : 'item-content-normal'">
                    <div :class="tempItem.name == item.active ? 'item-content-select' : 'item-content-notselect'">
                      {{ tempItem.title || "" }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="sendmessage-twoleveltree-div"
                v-for="(tempItem, tempIndex) in item.child"
                :key="'twoleveltree' + tempIndex"
                v-show="tempItem.name == item.active"
              >
                <div class="teas-body-tree-c">
                  <message-tree
                    class="teas-body-tree"
                    :name="tempItem.name"
                    :ref="tempItem.name"
                    :apiAddress="tempItem.url"
                    :sms-data="tempItem"
                    @handleAdd="handleAddUser"
                    @call-back="childCallback"
                  />
                </div>
              </div>
            </div>
          </template>
        </div> -->
        <!-- 手动添加 -->
        <!-- <div class="teas-body-sd" v-show="navActive === 'manual'">
          <el-form
            label-position="top"
            label-width="80px"
            :model="formLabelAlign"
            class="teas-body-sd-form"
            ref="form"
          >
            <el-form-item
              label="姓名"
              prop="name"
              :rules="[
                { required: true, message: '姓名不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                v-model="formLabelAlign.name"
                :validate-event="false"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="手机号码"
              prop="phoneNumber"
              :rules="[
                {
                  required: true,
                  message: '手机号码不能为空',
                  trigger: 'blur',
                },
                {
                  type: 'phone',
                  validator: phoneValidate,
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="formLabelAlign.phoneNumber"
                :validate-event="false"
                placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>
            <el-button
              class="teas-body-add"
              @click="handleAddPeo"
            >添加</el-button
            >
          </el-form>
        </div> -->
        <!-- 额外增加的选项 -->
        <!-- <div
          class="teas-other-content"
          v-for="(item, index) in slots"
          v-show="item.name === navActive"
          :key="index"
          :name="item.name"
        >
          <component
            :is="item.type"
            :ref="item.name"
            class="teas-body-tree"
            :name="item.name"
            :apiAddress="item.apiAddress"
            @handleAdd="handleAddUser"
          ></component>
        </div> -->
      </div>
      <div class="teas-body-right">
        <div class="teas-body-receive">
          <div class="teas-body-title">
            <div>收件人</div>
            <div class="teas-body-title-right-button-div">
              <span class="template-div el-icon-circle-close" @click="handleClearError"> 清除错误格式</span>
              <span class="template-div el-icon-delete" @click="handleClearAllPeo"> 清空</span>
              <span class="template-div el-icon-warning-outline" @click="handleTips">&nbsp;提示</span>
            </div>
          </div>
          <div class="teas-body-title-peo" @click.self="clickReceiveView">
            <!-- 系统人员 -->
            <template v-for="(item, key) in receives">
              <div v-for="(value, i) in item" :key="i + key" class="teas-body-receive-item" @dblclick="editReceives(value, i, key)">
                <!-- 编辑时显示对应的可编辑内容 -->
                <span v-show="i + key != isShowEdit">
                  {{ value.name }}（<span
                    :class="{
                      error: formatPhone(value, i, key) || value.error,
                    }"
                  >
                    {{ value.phone }}</span
                  >）<i class="el-icon-close" @click="handleClearPeo(i, key, value.id)"></i>
                </span>
                <span v-show="i + key === isShowEdit">
                  <span class="white">（{{ editValue }}）</span>
                  <el-input class="edit-receives" v-model="editValue" v-show="isEdit" @change="changeBlur(editValue, i, key)" @blur="editBlur" />
                </span>
              </div>
            </template>
            <div class="teas-body-receive-item-input">
              <el-autocomplete
                v-model="inputPeopleString"
                :fetch-suggestions="querySearchAsync"
                :trigger-on-focus="false"
                placeholder="搜索或粘贴收件人"
                ref="receiveInput"
                @select="handleSelect"
                @change="inputBlur"
                @focus="inputFocus"
              ></el-autocomplete>
            </div>
            <!-- 手动添加人员 -->
            <!-- <div
              class="teas-body-receive-item"
              v-for="(item, index) in handleList"
              :key="index"
            >
              {{ item.name }}（{{ item.phoneNumber }}）<i
                class="el-icon-close"
                @click="handleClearPeo(index, 'handle')"
              ></i>
            </div> -->
          </div>
          <div class="teas-body-title-foot">
            共<span>{{ sendUser }}</span
            >人
          </div>
        </div>
        <div class="teas-body-content">
          <div class="teas-body-title">
            <span>短信内容</span>
            <div class="teas-body-title-right-button-div">
              <span class="template-div" @click="handleSuffix">短信后缀</span>
              <span class="template-div" @click="handleTemplate">短信模板</span>
            </div>
          </div>
          <div class="teas-body-title-peo">
            <!-- <el-input
              class="textarea"
              type="textarea"
              :rows="8"
              :max="contentLength"
              placeholder="请输入短信内容"
              v-model="messageContent"
              resize="none"
            >
            </el-input> -->

            <div contenteditable="true" class="text-area" ref="textarea" @input="textInput" @keyup="textInput"></div>
          </div>
          <div class="teas-body-title-content-last">
            {{ messageContentLastObject.text ? "(" + messageContentLastObject.text + ")" : "" }}
          </div>
          <div class="teas-body-title-foot">
            合计字数<span>{{ currentLength }}</span> ，请控制在{{ contentLength }}字以内
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import messageTree from "./sendMessageTree.vue";
import indexBar from "./indexBar.vue";
export default dsf.component({
  name: "DsfPlatformTeasWirte",
  ctrlCaption: "短信首页",
  mixins: [$mixins.control],
  components: { messageTree, indexBar },
  props: {
    contentLength: {
      type: Number,
      default: 300,
    },
    // 标签配置
    tabConfig: {
      type: Array,
      default: () => [
        {
          title: "校内成员",
          name: "schoolperson",
          haschild: false,
          // hide: false,
          // lazy: false,
          url: "/sms/sms-info/getUnitUserTree",
          child: [],
          configParams: "", // 配置参数 用于tree 显示
        },
      ],
    },
    activeTab: {
      type: String,
      default: "schoolperson",
    },
  },
  created() {
    // 获取再次编辑数据
    // dialog && location
    let tempArray = this.tabConfig || [];
    this.defaultNavList = tempArray.map((item) => {
      let tempItem = item;
      if (tempItem.child.length > 0 && tempItem.haschild) {
        tempItem.active = tempItem.child[0].name || "";
        // this.twoLevelActive = tempItem.child[0].name;
        // this.$set(this.twoLevelActive, tempItem.name, tempItem.child[0].name);
        this.twoLevelActive.push({ tabsName: tempItem.name, activeTab: tempItem.child[0].name });
      }
      return tempItem;
    });
    this.navActive = this.activeTab || "";
  },
  data() {
    return {
      messageId: "", // 再次编辑页面ID
      isRightNowSend: true, // 是否为立即发送
      sendDate: "", // 发送日期
      receives: {}, // 系统短信接受人
      inputPeopleString: "",
      handlerAddName: "handlerAdd",
      messageContentLastObject: {},
      inputIsFocus: false,
      receivesList: [], // 编辑时拿到的数据
      handleList: [], // 手动添加人员
      defaultProps: { children: "children", label: "name" },
      messageContent: "", // 短信内容
      navActive: "", // 搜索树导航激活菜单
      navMargin: 0, // 菜单移动距离
      formLabelAlign: {}, // 手动添加
      defaultNavList: [], // 导航菜单
      treeData: [], // 树数据
      accept: ".xlsx,.xls",
      action: "/sms/sms-info/preimport/excel",
      editValue: "",
      isEdit: false,
      isShowEdit: "",
      errorPhone: "",
      currentLength: 0,
      blackList: "",
      sensitiveWords: "",
      twoLevelActive: [],
      isDialogEdit: false,
      templateCode: "",
    };
  },
  computed: {
    allNavList() {
      return [...this.defaultNavList];
    },
    sendUser() {
      let all = 0;
      Object.keys(this.receives).map((re) => {
        all += this.receives[re].length;
      });
      all += this.handleList.length;
      return all;
    },
  },
  methods: {
    twoLevelActiveFind(tabsName) {
      var tab = this.twoLevelActive.find((item) => {
        return item.tabsName == tabsName;
      });
      return tab.activeTab;
    },
    childCallback(treeName) {
      let setNodes = [];
      // tab切换时
      if (this.isDialogEdit) {
        // console.log("111111", treeName, this.isDialogEdit, this.handlerAddName, this.receivesList);
        this.$nextTick(() => {
          if (treeName.$refs?.tree) {
            treeName.$refs.tree.setCheckedNodes(this.receivesList);
          } else {
            // bar 数据 直接设置选中值
            treeName.checkedItem = this.receivesList;
            treeName.checkedLists = _.map(treeName.checkedItem, (item) => item.id);
          }
          // treeName.$refs.tree.setCheckedNodes(this.receivesList);
          // setNodes = this.receivesList;
          // this.$set(this.receives, treeName.name, setNodes);
        });
      } else {
        // 待发短信编辑 草稿编辑  只请求一次
        if (this.$dialog?.dialogArgs?.messageId) {
          let { messageId, type } = this.$dialog.dialogArgs;
          this.$http.get("/sms/sms-info/message", { messageId, type }).done((re) => {
            if (re.success) {
              this.receivesList = re.data.receivers;
              this.$refs.textarea.innerHTML = re.data.content;
              this.currentLength = this.$refs?.textarea.innerText.replace(/(<[\w\W]+?>)|\s*/gi, "").length;
              this.messageContent = re.data.content;
              this.sendDate = re.data.sendTime;
              this.isRightNowSend = re.data.sendNow;
              this.smsMessageId = re.data.smsMessageId;
              let suffixUser = re.data.suffixUser;
              let suffix = re.data.suffix;
              if (suffixUser && !suffix) {
                this.messageContentLastObject = { text: "自己", value: "-2" };
              } else {
                this.messageContentLastObject = suffix;
              }
              // 回显左侧树
              this.$nextTick(() => {
                // tree 数据
                if (treeName.$refs?.tree) {
                  treeName.$refs.tree.setCheckedNodes(this.receivesList);
                  // setNodes = treeName.$refs.tree.getCheckedNodes();
                  // this.$set(this.receives, treeName.name, treeName.checkedItem);
                } else {
                  // bar 数据 直接设置选中值
                  treeName.checkedItem = this.receivesList;
                  treeName.checkedLists = _.map(treeName.checkedItem, (item) => item.id);
                  // this.$set(this.receives, treeName.name, treeName.checkedItem);
                }
                // 设置右侧所有数据
                this.$set(this.receives, treeName.name, this.receivesList);
                this.isDialogEdit = true;
              });
            } else {
              dsf.layer.message(re.message, false);
            }
          });
        }
      }
    },
    phoneValidate(rule, value, callback) {
      if (value && !/^1[0-9]{10}$/.test(value)) {
        callback(new Error("手机号码格式错误"));
      } else {
        callback();
      }
    },
    queryBlackList() {
      let bl = this.blackList;
      let node = {};
      _.forEach(this.receives, (item, key) => {
        // console.log(item, key);
        node[key] = [];
        _.forEach(item, (val) => {
          node[key].push({
            ...val,
            error: _.includes(bl, val.phone),
          });
        });
        this.$set(this.receives, key, node[key]);
      });
    },
    querySensitiveWords() {
      let data = this.sensitiveWords;
      let text = this.messageContent;
      if (this.sensitiveWords.length > 1) {
        _.forEach(data, (item) => {
          text = text.replace(new RegExp(item, "g"), `&nbsp<b style="color:red">${item}</b>&nbsp`);
        });
      } else {
        text = text.replace(new RegExp(data[0], "g"), `&nbsp<b style="color:red">${data[0]}</b>&nbsp`);
      }
      this.$refs.textarea.innerHTML = text;
    },
    textInput(event) {
      let innerText = event?.target?.innerText.replace(/(<[\w\W]+?>)|\s*/gi, "");

      if (innerText == "") {
        this.currentLength = 0;
        this.$refs.textarea.innerHTML = "";
        this.messageContent = "";
      } else {
        this.currentLength = innerText.length;
        this.messageContent = innerText;
        // if (this.sensitiveWords) {
        //   this.querysensitiveWords();
        // }
      }
    },
    getContent() {
      let text = this.$refs.textarea.innerText;
      text = text.replace(/(<[\w\W]+?>)|\s*/gi, "");
      return text;
    },
    /**
     * type (string) 事件类型
     */
    sendMessage(type) {
      let receives = [];
      let validatePhone = false;
      let { contentLength } = this.props;
      Object.keys(this.receives).map((re) => {
        receives.push(...this.receives[re]);
        // 过滤格式错误的手机号
        _.forEach(this.receives[re], (val) => {
          if (val.error) {
            validatePhone = true;
          }
        });
      });
      if (validatePhone) {
        //滚动到手机号错误的人员
        setTimeout(() => {
          const top = document.querySelector(".teas-body-receive-item .error");
          $(".teas-body-receive .teas-body-title-peo").scrollTop(((top && top.offsetParent && top.offsetParent.offsetTop) || 0) - 100);
          // document.querySelector(".teas-body-receive .teas-body-title-peo").scrollTo({
          //   top: ((top && top.offsetParent && top.offsetParent.offsetTop) || 0) - 100,
          //   behavior: "smooth",
          // });
        }, 500);
        dsf.layer.message("请修改收件人手机号黑名单或格式问题", false);
        return;
      }
      // validate
      if (!this.messageContent) {
        dsf.layer.message("请修改收件人或者短信内容", false);
        return;
      }
      if (this.currentLength > contentLength) {
        dsf.layer.message(`短信内容不能超过${contentLength}字`, false);
        return;
      }

      // let messageStringLength = this.messageContentLastObject.text
      //   ? this.messageContent.length + this.messageContentLastObject.text.length
      //   : this.messageContent.length;
      // if (messageStringLength > contentLength) {
      //   dsf.layer.message(`短信内容不能超过${contentLength}字`, false);
      //   return;
      // }
      if (!this.isRightNowSend && !this.sendDate) {
        dsf.layer.message("请选择短信发送时间", false);
        return;
      }
      if (this.sendUser === 0) {
        dsf.layer.message("请填写短信收件人", false);
        return;
      }
      let formatter = {
        templateCode: this.templateCode,
        content: this.messageContent,
        sendNow: this.isRightNowSend,
        sendTime: dsf.date.format(this.sendDate, "yyyy-mm-dd hh:ii:ss"),
        receivers: [...receives],
        type,
      };
      if (this.messageContentLastObject.value) {
        if (this.messageContentLastObject.value.length > 0) {
          if (this.messageContentLastObject.value == "-2") {
            formatter.suffixUser = dsf.getCookie("userId") || "";
          } else if (this.messageContentLastObject.value == "-1") {
            console.log(11);
          } else {
            formatter.suffix = this.messageContentLastObject;
          }
        }
      }
      if (this.smsMessageId) {
        formatter["smsMessageId"] = this.smsMessageId;
      }
      let loading = dsf.layer.loading();
      this.$http
        .post(`/sms/sms-info/save`, JSON.stringify(formatter), {
          headers: { "Content-Type": "application/json;charset=UTF-8" },
        })
        .done((res) => {
          if (res.success) {
            // 清空之前的信息
            this.sendDate = "";
            this.handleList = [];
            this.messageContent = "";
            // 清空数据
            this.currentLength = 0;
            this.$refs.textarea.innerHTML = "";
            this.messageContentLastObject = {};
            this.formLabelAlign = {};
            this.clearAllPeo();
            // 待发短信编辑 草稿编辑
            if (this.$dialog && this.$dialog.dialogArgs?.messageId) {
              this.$dialog.close();
            }
            dsf.layer.message(res.message);
          } else {
            // 发送短信部分失败情况
            if (type === "send" && res.data.type === "confirm") {
              dsf.layer
                .confirm(`${res.message}`)
                .then((re) => {
                  let path = "#/pc/sms/sent/senddetails?smsMessageId=" + res.data.id;
                  dsf.layer.openDialog({
                    title: "发送详情",
                    width: "80vw",
                    height: "70vh",
                    showClose: true,
                    params: {
                      path: path,
                    },
                    btns: [
                      {
                        text: "关闭",
                      },
                    ],
                  });
                })
                .catch((e) => e);
            } else {
              // mgc/hmd
              if (res.state == 20032) {
                //  黑名单
                this.blackList = res.data.split("、");
                this.queryBlackList();
              } else if (res.state == 20033) {
                // "敏感词"
                this.sensitiveWords = res.data.split("、");
                this.querySensitiveWords();
              }
              dsf.layer.message(res.message, false);
            }
          }
        })
        .error((err) => {
          dsf.layer.message((err && err.message) || "请求异常", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    // 清空错误格式
    handleClearError() {
      let node = {};
      _.forEach(this.receives, (item, key) => {
        node[key] = [];
        _.forEach(item, (val) => {
          if (!val.error) {
            node[key].push(val);
          }
        });
        this.$set(this.receives, key, node[key]);
        dsf.layer.message("已清除错误格式手机号。");
      });
    },
    // 发送短信
    handleSendMessage(type) {
      this.sendMessage(type);
    },
    // 切换发送方式
    handleSend() {
      this.isRightNowSend = !this.isRightNowSend;
    },
    // 选择导航树
    handleChangeNav(tab, event) {
      this.navActive = tab.name;
      // console.log(tab, event);
    },
    // 左、右移动导航栏
    handleMoveNav(isLeft) {
      if (isLeft) {
        if (this.navMargin < 0) {
          this.navMargin += 480;
        }
      } else {
        if (Math.abs(this.navMargin) < Math.ceil(this.allNavList.length / 4 - 1) * 480) {
          this.navMargin -= 480;
        }
      }
    },
    // 从树/列表 组件添加选中用户信息
    handleAddUser(name, data) {
      // console.log(this.isDialogEdit, name, data);
      if (this.isDialogEdit && this.receives?.default) {
        let selData = _.map(data, (item) => item.id);
        // 默认数据
        let dft = _.filter(this.receives?.default, (item) => {
          return _.indexOf(selData, item.id) == -1;
        });
        this.$set(this.receives, "default", dft);
        // console.log(this.receives?.default);
      }
      this.$set(this.receives, name, data);
    },
    editBlur() {
      this.isShowEdit = "";
    },
    changeBlur(res, i, name) {
      let tempArray = this.receives[name] || [];
      let tempObject = {
        ...tempArray[i],
        name: res.slice(0, -11),
        phone: res.slice(-11),
        error: false,
      };
      tempArray.splice(i, 1, tempObject);
      this.isShowEdit = "";
    },
    // 编辑当前人
    editReceives(res, i, name) {
      this.isEdit = true;
      this.isShowEdit = i + name;
      this.editValue = res.name + res.phone;
    },
    formatPhone(str, index, type) {
      // let regx = /(^1(3|4|5|7|8|9|6)\d{9}$|^0[\d]{2,3}-[\d]{7,8}$|^400[-]?[\d]{3}[-]?[\d]{4}$)/g;
      let regx = /^1(3|4|5|7|8|9|6)\d{9}$/g;
      let phoneNums = regx.test(str.phone);
      if (!phoneNums) {
        str.error = true;
        // console.log("记录错误的", index, type);
      }
      return !phoneNums;
    },

    // 删除选中的人
    handleClearPeo(index, type, key) {
      if (type === "handle") {
        this.handleList.splice(index, 1);
      } else {
        // 弹窗数据删除
        if (this.isDialogEdit) {
          // 删除数据的id 无id直接删除
          let delId = this.receives[type][index]?.id;
          let parentVm = this.$refs[this.navActive]; // 当前激活tab
          if (delId) {
            if (parentVm[0].$refs?.tree) {
              let treeData = _.filter(parentVm[0].$refs.tree.getCheckedNodes(), (key) => key.id != delId);
              parentVm[0].$refs.tree.setCheckedNodes(treeData);
              // console.log("手动tree数据", treeData);
            } else {
              // console.log("手动子级 bar");
              parentVm[0].checkedItem = _.filter(parentVm[0].checkedItem, (key) => key.id != delId);
              parentVm[0].checkedLists = _.filter(parentVm[0].checkedLists, (key) => key != delId);
            }
          }
          // 删除当前数据
          this.receives[type].splice(index, 1);
        } else {
          // console.log("???手动添加的数据");
          let data = this.receives[type];
          let removeData = data.splice(index, 1);
          let parentVm = this.$refs[type];
          if (Object.prototype.toString.call(parentVm) === "[object Object]") {
            parentVm.$refs.tree.setCheckedNodes(data);
          } else if (Object.prototype.toString.call(parentVm) === "[object Array]") {
            // tree 数据
            if (parentVm[0].$refs?.tree) {
              parentVm[0].$refs.tree.setCheckedNodes(data);
              fixTreeChecked(
                {
                  [removeData[0].id]: false,
                },
                parentVm[0].$refs.tree
              );
              // var ids = data.map((item) => {
              //   return item.id;
              // });
              // parentVm[0].$refs.tree.setCheckedKeys(ids);
              // console.log(parentVm[0].$refs.tree.getCheckedKeys());
            } else {
              // bar 数据 直接设置选中值
              parentVm[0].checkedItem = data;
              parentVm[0].checkedLists = _.map(data, (item) => item.id);
            }
          } else {
            return;
          }
          this.$set(this.receives, type, data);
        }
      }
    },
    // 清空所有人
    handleClearAllPeo() {
      dsf.layer
        .confirm("是否清空所有人？")
        .then(() => {
          this.clearAllPeo();
        })
        .catch(() => {});
    },
    clearAllPeo() {
      let keyArr = Object.keys(this.receives);
      keyArr.forEach((type) => {
        if (type != this.handlerAddName) {
          let parentVm = this.$refs[type];
          if (Object.prototype.toString.call(parentVm) === "[object Object]") {
            parentVm.$refs.tree.setCheckedNodes([]);
          } else if (Object.prototype.toString.call(parentVm) === "[object Array]") {
            // tree 数据
            if (parentVm[0].$refs?.tree) {
              parentVm[0].$refs.tree.setCheckedNodes([]);
              const treeVm = parentVm[0].$refs.tree;
              setTimeout(() => {
                let nodes = treeVm.getCheckedNodes();
                let nodeKeyMap = {};
                for (let i = 0; i < nodes.length; i++) {
                  nodeKeyMap[nodes[i].id] = false;
                }
                fixTreeChecked(nodeKeyMap, treeVm);
              });
            } else {
              // bar 数据 直接设置选中值
              parentVm[0].checkedItem = [];
              parentVm[0].checkedLists = [];
            }
          } else {
            return;
          }
        }
        this.$set(this.receives, type, []);
      });
      this.receivesList = [];
    },
    // 手动添加联系人
    handleAddPeo() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.handleList.push(Object.assign({}, this.formLabelAlign));
          this.formLabelAlign = {};
        } else {
          return false;
        }
      });
    },
    // 短信模板
    handleTemplate() {
      let _this = this;
      this.$openDialog({
        title: "短信模版",
        width: "1000px",
        height: "60vh",
        params: {
          path: "#/pc/sms/module/template/sendModuleList?isView=1",
        },
        btns: [
          {
            text: "确定",
            handler(res) {
              let tempDic = res.$refs.view.$refs.datagrid1.multipleSelection || {};
              if (!tempDic["_id"]) {
                dsf.layer.message("请选择短信模版", false);
                return;
              } else {
                _this.templateCode = tempDic["sms_module_template.code"];
                _this.messageContent = _this.messageContent + tempDic["sms_module_template.content"];
                _this.$refs.textarea.innerHTML = _this.messageContent;
                _this.currentLength = _this.$refs.textarea.innerText.replace(/(<[\w\W]+?>)|\s*/gi, "").length;
              }
            },
          },
          {
            text: "取消",
          },
        ],
      });
    },
    handleSuffix() {
      let _this = this;
      this.$openDialog({
        title: "短信后缀",
        width: "800px",
        height: "200px",
        params: {
          path: "#/pc/sms/suffix/suffixSelect",
        },
        dialogArgs: { messageSuffix: this.messageContentLastObject },
        btns: [
          {
            text: "确定",
            handler(res) {
              _this.messageContentLastObject = res.$refs.view.chooseGroup || {};
            },
          },
          {
            text: "取消",
          },
        ],
      });
    },
    clickTwoTab(index, tempItem) {
      // let tempOneItem = this.defaultNavList[index];
      // if (tempOneItem.active == tempItem.name) {
      //   return;
      // }
      // tempOneItem.active = tempItem.name || "";
      // this.$set(this.defaultNavList, index, tempOneItem);
    },
    //输入框检索
    querySearchAsync(serchString, callback) {
      this.$http
        .get("/sms/sms-info/person/search", {
          searchValue: serchString || "",
          pageNum: 1,
          pageSize: 100,
        })
        .done((re) => {
          if (re.success) {
            let tempData = re.data || [];
            tempData.map((item) => {
              let tempItem = item;
              tempItem.value = item.name + "（" + item.phone + "）";
              return tempItem;
            });
            callback(tempData);
          } else {
            callback([]);
            // dsf.layer.message(re.message);
          }
        })
        .error((re) => {
          callback([]);
        });
    },
    //输入框选择
    handleSelect(res) {
      let tempArray = this.receives[this.handlerAddName] || [];
      let tempObject = {
        id: res.id,
        name: res.name,
        phone: res.phone,
      };
      tempArray.push(tempObject);
      this.$set(this.receives, this.handlerAddName, tempArray);
      this.inputPeopleString = "";
    },
    inputBlur(res) {
      setTimeout(() => {
        this.inputIsFocus = false;
        if (this.inputPeopleString.length == 0) {
          return;
        }
        // 有数据 并且没手动选择
        let data = res.replace(/,|，|;|；/g, "&").split("&");
        let tempPeopleArray = this.receives[this.handlerAddName] || [];
        if (data.length > 1) {
          _.forEach(data, (list) => {
            tempPeopleArray.push({
              id: "",
              name: list.slice(0, -11),
              phone: list.slice(-11),
            });
          });
        } else {
          tempPeopleArray.push({
            id: "",
            name: data[0].slice(0, -11),
            phone: data[0].slice(-11),
          });
        }
        this.$set(this.receives, this.handlerAddName, tempPeopleArray);
        this.inputPeopleString = "";
      }, 200);
    },
    inputFocus() {
      this.isShowEdit = "";
      this.inputIsFocus = true;
    },
    selectPhoneNumber(str) {
      var regx = /(^1(3|4|5|7|8|9|6)\d{9}|0[\d]{2,3}-[\d]{7,8}|400[-]?[\d]{3}[-]?[\d]{4})/g;
      var phoneNums = str.match(regx);
      if (phoneNums) {
        if (phoneNums.length > 0) {
          return phoneNums[0];
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    clickReceiveView() {
      // 编辑时也退出
      this.isShowEdit = "";
      if (!this.inputIsFocus) {
        this.$refs.receiveInput.focus();
      }
    },
    handleImportPhone(idString) {
      //导入手机号
      let _this = this;
      this.$openDialog({
        title: "预导入文件编辑",
        width: "80%",
        height: "500px",
        center: true,
        params: {
          path: "#/pc/sms/send/import/edit?id=" + idString,
        },
        btns: [
          {
            text: "确定",
            async handler(res) {
              if (res && res.yes && !(await res.yes())) return false;
              _this.$http
                .get("/sms/sms-info/preimport/clean", {
                  id: idString,
                })
                .done((re) => {})
                .error((re) => {});
              let uploadData = res.$refs.view.$viewData["sms_send_import_user"] || [];
              let tempPeopleArray = _this.receives[_this.handlerAddName] || [];
              uploadData.forEach((item) => {
                let tempItem = {
                  id: "",
                  name: item["sms_send_import_user.name"] || "",
                  phone: item["sms_send_import_user.phone"] || "",
                };
                tempPeopleArray.push(tempItem);
              });
              _this.$set(_this.receives, _this.handlerAddName, tempPeopleArray);
            },
          },
          {
            text: "关闭",
          },
        ],
      });
    },
    downloadMode() {
      //下载模版
      let tempButtons = _.keyBy(dsf.buttons.getPcButtons(), "actionName");
      let tempButton = tempButtons["system_template_download"];
      if (tempButton) {
        tempButton.handler.call(this, {
          owner: this,
          params: ["e52ee56f7f1b4d85a74832bccd0f45d9", "短信手机号导入模板.xlsx"],
        });
      }
    },
    uploadProgress() {
      this.loading = dsf.layer.loading();
    },
    uploadSuccess(args) {
      dsf.layer.closeLoading(this.loading);
      this.loading = undefined;
      let idString = args.data || "";
      this.handleImportPhone(idString);
    },
    uploadError() {
      dsf.layer.closeLoading(this.loading);
      this.loading = undefined;
      dsf.layer.message("上传失败", false);
    },
    handleTips() {
      dsf.layer.alert({
        title: "提示信息",
        message: "收件人可复制粘贴，多个号码请用用英文的逗号/分号来区分，例如：张三13310100000；李四15110101525,张强16111110000",
        showConfirmButton: false,
      });
    },
  },
});

function fixTreeChecked(nodeKeyMap, treeVm) {
  const root = treeVm.root;
  fixTreeCheckedDeep(root, nodeKeyMap);
}
function fixTreeCheckedDeep(node, keyMap, check) {
  if (dsf.type(keyMap[node.data.id]) == "boolean") {
    node.checked = keyMap[node.data.id];
  }
  // else if (dsf.type(check) == "boolean") {
  //   node.checked = check;
  // }
  if (node.childNodes.length) {
    for (let i = 0; i < node.childNodes.length; i++) {
      fixTreeCheckedDeep(node.childNodes[i], keyMap, node.checked);
    }
  }
}
</script>
